export enum RolesPermission {
  MEMBER = 'Member',
  ADMINISTRATOR = 'Administrator',
}
